class Breadcrumb {
  element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  init() {
    this.handleExpandBreadcrumbOnMobile();
  }

  handleExpandBreadcrumbOnMobile() {
    const currentPage = this.element.querySelector<HTMLElement>('.arjo-m-breadcrumb__remaining-item--current-page');

    if (!currentPage) return;

    currentPage.addEventListener('click', () => {
      const mobileDots = this.element.querySelector<HTMLElement>('.arjo-m-breadcrumb__mobile-dots');
      const remainingItems = this.element.querySelectorAll('.arjo-m-breadcrumb__remaining-item');

      if (!mobileDots) return;

      if (!mobileDots.classList.contains('hide')) {
        mobileDots.classList.add('hide');
        remainingItems?.forEach(item => window.getComputedStyle(item).display === 'none' && item.classList.add('show'));
      } else {
        mobileDots.classList.remove('hide');
        remainingItems?.forEach(item => item.classList.remove('show'));
      }
    })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const breadCrumbs = document.querySelectorAll<HTMLElement>('.arjo-m-breadcrumb');

  breadCrumbs.forEach((breadcrumb) => new Breadcrumb(breadcrumb).init());
});
